// Updates the resource path in a cloned Resource to be used in a different endpoint
export const cloneResourceWithPath = (Resource, alternativePath) => {
    return Object.assign(Object.create(Object.getPrototypeOf(Resource)), Resource, {
        path: alternativePath,
    });
};
//# sourceMappingURL=Resource.js.map